import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation, forwardRef, input, output } from "@angular/core";
import { Wrapper } from "../wrapper.interface";
import { SplitbuttonConfig } from "./splitbutton.config";
import { CommonModule } from "@angular/common";
import { WRAPPER_TOKEN } from "../wrapper.tokens";
import { FaPrefix } from 'src/app/components/v-icon/types';
import { TranslateModule } from "@ngx-translate/core";
import { VIconComponent } from "src/app/components/v-icon/v-icon.component";
import { SplitButtonModule } from "primeng/splitbutton";
import { SplitButtonOption } from "./splitbutton.interface";
import { GcRowContainerComponent } from "src/app/components/v-layout/row/row.component";
import { IconPosition } from "../button/button.config";

@Component({
    selector:        'v-splitbutton',
    templateUrl:     './splitbutton.component.haml',
    styleUrls:       ['./splitbutton.component.sass', '../style.sass'],
    encapsulation:   ViewEncapsulation.None,
    providers:       [{ provide: WRAPPER_TOKEN, useExisting: forwardRef(() => VSplitbuttonComponent) }],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone:      true,
    imports:         [SplitButtonModule, VIconComponent, CommonModule, TranslateModule, GcRowContainerComponent]
})
export class VSplitbuttonComponent extends Wrapper<SplitbuttonConfig>{
    protected _baseConfig: SplitbuttonConfig = SplitbuttonConfig.baseTheme.Default;
    public onClick = output<MouseEvent>();
    public onFocus = output<FocusEvent>();
    public onBlur = output<FocusEvent>();

    public ariaLabel = input(undefined, {alias: "aria-label"});
    public iconPosition = input<IconPosition>();
    public icon = input<string>();
    public labelInput = input<string>(undefined, {alias: "label"});
    public prefix = input<FaPrefix>("fas");
    public buttonType = input<string>(undefined, {alias: "type"});
    public options = input.required<SplitButtonOption[]>();

    @HostBinding("class.v-button-full") private get isFull() {
        return (this.buttonType() ?? this.config()?.type) === "full";
    }
}